import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import OggettiUtili from "../../utils/OggettiUtili";
import TabelleMonitoraggio from "./TabelleMonitoraggio";
import {states} from '../Wizard/States/States';

class InserimentoSegnalazioni extends Component {

    state = {

        malattie: JSON.parse(sessionStorage.getItem("malattie")),
        filtriSegnalazione: {
            malattia: "",
            utenteInserimento: "",
            gruppoStatoSegnalazione: "",
            statoSchedaSpeciale: "",
            dataDa: "",
            dataA: "",
            statoInvio: ""
        },

    }

    rowsFiltri = [
        {
            malattia: {
                id: "malattia",
                text: "malattia",
                tipo: "autocomplete",
                field: "malattia",
                numeroCol: 1,
                suggestions: this.state.malattie,
                keyField: "codice",
                descriptionField: "codDesc",
                suggestionField: "descrizione"
            },
            gruppoStatoSegnalazione: {
                id: "gruppoStatoSegnalazione", text: "", tipo: "select", field: "gruppoStatoSegnalazione", numeroCol: 2,
                suggestions: OggettiUtili.statoSchedaStandard, defaultSelect: "--Scheda Standard--"
            },
            dataDa: {
                id: "dataDa",
                text: "dataDa",
                tipo: "data",
                field: "dataDa",
                placeholder: "data segnalazione da",
                numeroCol: 3
            }
        },
        {
            utenteInserimento: {
                id: "utenteInserimento",
                text: "Utente inserimento",
                tipo: "input",
                field: "utenteInserimento",
                numeroCol: 1
            },
            statoSchedaSpeciale: {
                id: "statoSchedaSpeciale", text: "", tipo: "select", field: "statoSchedaSpeciale", numeroCol: 2,
                suggestions: OggettiUtili.statoSchedaSpeciale, defaultSelect: "--Scheda Speciale--"
            },
            dataA: {
                id: "dataA",
                text: "dataA",
                tipo: "data",
                field: "dataA",
                placeholder: "data segnalazione a",
                numeroCol: 3
            }
        }

    ]

   colsTabMonitoraggio = [
        {
            key: "malattia", name: "Malattia", sortDirection: "none", tipo: "dizionario",
            oggetto: JSON.parse(sessionStorage.getItem("malattiePerCodice")), campo: "descrizione"
        },
        {
            key: "idSegnalazione",
            name: "ID Segnalazione",
            sortDirection: "none",
            tipo: "link",
            path: "/wizardSegnalazione",
            nomeParametro: "idSegnalazione",
            state: {currentState: states.DATI_SEGNALAZIONE_E_ANAGRAFICI}
        },
        {key: "ulssSegnalazione", name: "ULSS di segnalazione", sortDirection: "none", tipo: "dizionario", oggetto: OggettiUtili.Ulss},
        {key: "utenteInserimento", name: "Utente Inserimento", sortDirection: "none"},
        {key: "nome", name: "Nome", sortDirection: "none"},
        {key: "cognome", name: "Cognome", sortDirection: "none"},
        {key: "dataSegnalazione", name: "Data segnalazione", sortDirection: "none", tipo: "data"},
        {key: "scadenza", name: "Tables.Home.scadenza", sortDirection: "none"},
        {
            key: "statoSegnalazione",
            name: "Scheda Standard",
            sortDirection: "none",
            tipo: "pallino",
            oggetto: OggettiUtili.statoSegnalazione
        },
        {
            key: "statoSchedaSpeciale",
            name: "Scheda Speciale",
            sortDirection: "none",
            tipo: "pallino",
            oggetto: OggettiUtili.informazioniTabella
        },
       {
            key: "prosegui", tipo: "link", label: "Prosegui", path: "/wizardSegnalazione",
            nomeParametro: "idSegnalazione"
        }
    ]

    constructor(props) {
        super(props);
        this.setStateGenericoSegnalazione = this.setStateGenericoSegnalazione.bind(this)
        this.sendFiltriSegnalazione = this.sendFiltriSegnalazione.bind(this)

    }

    setStateGenericoSegnalazione(object) {
        this.setState(object)
    }

    sendFiltriSegnalazione(filtri) {
        this.props.creaFiltri({filtri: filtri})
    }

    render() {

        return (
            <div>
                <TabelleMonitoraggio
                    cols={this.colsTabMonitoraggio}
                    title={"Stato Segnalazioni"}
                    emptyMsg={"Non ci sono segnalazioni"}
                    lengthEditable={true}
                    homePage={true}
                    information={["01", "07", "00", "02"]}
                    rowFiltri={this.rowsFiltri}
                    filtri={this.state.filtriSegnalazione}
                    sendFiltri={this.sendFiltriSegnalazione}
                    inserimentoSegnalazioni = {"1"}
                    ruolo={"r"}
                    setStateGenerico={this.setStateGenericoSegnalazione}
                />
            </div>
        )
    }


}

export default withTranslation('common')(InserimentoSegnalazioni);

